import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { Order } from '~src/spacesPlatform/models/sort/Order';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';

import { Messages } from '../../../../codegen/Localize';
import { OrderKeys } from '../../../../spacesPlatform/models/OrderKeys';

export const WorkbookSubspaceDataConnectionSortOptions: OptionsDictionary = {
  'type': SortOptions.connectionType,
  'datasource': {
    id: 'datasource',
    getMenuItemDisplayValue: Messages.datasource,
    subSortOptions: {
      'asc': {
        id: 'datasource.asc',
        field: OrderKeys.name,
        ascending: true,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByDataSourceAsc,
        toOrderClauseArray: () => [Order.asc(OrderKeys.name)]
      },
      'desc': {
        id: 'datasource.desc',
        field: OrderKeys.name,
        ascending: false,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByDataSourceDesc,
        toOrderClauseArray: () => [Order.desc(OrderKeys.name)]
      }
    }
  }
};


export const dataConnectionSortOptions: OptionsDictionary = {
  'relevance': SortOptions.relevance,
  ...WorkbookSubspaceDataConnectionSortOptions
};
